export const PATIENT_AVAILABILITY_INPUT_NAME = 'patient-screening-availability'
export const PATIENT_AVAILABILITY_DURATION_INPUT_NAME =
  'patient-screening-availability-duration'
export const TRIAL_ID_TOKEN_INPUT_NAME = 'trialApplicationIdToken'
